import { IconButton } from "@mui/material";
import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

import { PIC } from "@ryde/assets";

import { FramerTooltip } from "../../../common";

export const RemoveFilteringIcon = (): ReactNode => {
  const { t } = useTranslation();
  return (
    <FramerTooltip content={t("general.CLEAR_FILTER")}>
      <IconButton>
        <PIC.FilterClearSvg data-e2e="remove-filtering-report-icon-svg" />
      </IconButton>
    </FramerTooltip>
  );
};
